import './PaymentSuccessful.scss';

import { any, bool, object } from 'prop-types';
import React, { Fragment, useMemo } from 'react';
import { connect } from 'react-redux';

import { Text } from '@sitecore-jss/sitecore-jss-react';
import { DELIVERY_OPTION } from '@utils/constant';

const TKPaymentStatus = ({
  dataFields,
  currentCart,
  isLoading
}) => {
  const paymentSuccessDescText = useMemo(() => {
    if (currentCart) {
      const firstLineInCart = currentCart?.Lines?.[0];
      const deliveryOptionsList = firstLineInCart?.DeliveryOptions || [];

      const deliveryOptionSelected = deliveryOptionsList.find((option) => option?.ExternalId
        === firstLineInCart?.DeliveryOptionId);

      const isBOPISOrder = deliveryOptionSelected?.ShippingOptionType?.Value === DELIVERY_OPTION.PickUpStore;

      return isBOPISOrder
        ? dataFields?.['BOPIS Description']
        : dataFields?.['Processing Now Text'];
    }

    return null;
  }, [dataFields, currentCart]);

  return dataFields && (
    <Fragment>
      <div className='payment-success'>
        <div className='container text-center'>
          <div className='payment-success__image'>
            <img src={require('@assets/images/success-icon.png')} alt='green tick' />
          </div>
          <Text
            field={dataFields['Payment Successfull Label']}
            tag='h3'
            editable={true}
            className='payment-success__text'
          />
          <Text
            field={dataFields['Thank You For Your Order Label']}
            tag='h3'
            editable={true}
            className='payment-success__thankyou'
          />
          {!isLoading && paymentSuccessDescText ? (
            <Text
              field={paymentSuccessDescText}
              tag='p'
              editable={true}
              className='payment-success__desc text-center'
            />
          ) : (
            <div className='skeleton__item'>
              <span className='text-line-24'></span>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

TKPaymentStatus.propTypes = {
  dataFields: object,
  currentCart: any,
  isLoading: bool
};

const mapStateToProps = (state) => (
  {
    currentCart: state.myOrderReducer.orderByIdReducer.currentCart,
    isLoading: state.myOrderReducer.orderByIdReducer.isLoading
  }
);

export default connect(mapStateToProps)(TKPaymentStatus);
